import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/Col";
import Coverimg from "../../../UserProfile/Components/Coverimg/Cover";
import Profileimg from "../../../UserProfile/Components/Profileimg/profileimg";
import Profiletitle from "../../../UserProfile/Components/ProfileTitle/profiletitle";
import Profilesection from "../../../UserProfile/Components/Profile_section_1/Profilesection";
import Timeline from "../../../../components/Timeline/timeline";
import BackArrow from "../../../../components/backArrow";
import { useMarketingProfileState } from "../../../../hooks/useMarketingProfileState";

const MarketingProfile = (props) => {
  const {
    leftSide,
    rightSide,
    name,
    tabsData,
    activeTab,
    infooo,
    setInfooo,
    loading,
    setLoading,
    createPost,
    setCreatePost,
    handleTabSelect,
    getActiveTabData,
    inputChange,
    userDatahandler,
    widthHandler,
    setCreateShop,
    marketerFor,
  } = useMarketingProfileState();

  return (
    <>
      <Container>
        <Row className="gx-3">
          <Col lg={leftSide} sm="12" className="ps-0 pe-0 screenHeight">
            <div className="b-radius border">
              <BackArrow back="/SellingSide" mystyle="ps-2 p-1" />
              <Coverimg
                widthHandler={widthHandler}
                inputChange={inputChange}
                userDatahandler={userDatahandler}
                setCreateShop={setCreateShop}
                infooo={infooo}
                name={name}
                setInfooo={setInfooo}
              />

              <Profileimg infooo={infooo} name={name} setInfooo={setInfooo} />

              <Profiletitle
                userDatahandler={userDatahandler}
                inputChange={inputChange}
                infooo={infooo}
              />
              <div className="bg-vilot">
                <Profilesection
                  userDatahandler={userDatahandler}
                  infooo={infooo}
                  setInfooo={setInfooo}
                  id={name?._id}
                  marketerFor={marketerFor}
                />
              </div>
            </div>
          </Col>

          <Col
            lg={rightSide}
            sm="12"
            className="ps-4 screenHeight"
            style={{ position: "relative" }}
          >
            <div className="border b-radius">
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab}
                onTabSelect={handleTabSelect}
                tabData={(getActiveTabData() || []).slice().sort((a, b) => {
                  const dateA = new Date(a.createdAt || 0);
                  const dateB = new Date(b.createdAt || 0);
                  return dateB - dateA;
                })}
                loading={loading}
                createPost={createPost}
                setCreatePost={setCreatePost}
                setLoading={setLoading}
                mybusinessType={createPost?.businessType}
                rightSide={rightSide}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MarketingProfile;
